import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { APPLE_STORE_URL, PLAY_STORE_URL } from '../../parameters'
import { RI_CLIC_ITI, TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { navigateToExternalUrl } from '../../store/history/historySlice'
import { delay } from '../../utils/function'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import { isAndroid, withOnlyPE } from '../Device'
import RectangleActionButton, { COLOR_BLUE, SIZE_MEDIUM } from '../genericComponents/buttons/RectangleActionButton'
import TagActionButton from '../genericComponents/TagActionButton'
import { getGpsLink } from './gps.utils'
import ItineraryButtonContainer from './ItineraryButtonContainer'
import mappyOutline from './mappy_outline.svg'

const hasNotBeenRedirected = () => !('hidden' in document ? document.hidden : document.webkitHidden)

const getGPSFallbackLink = () => (isAndroid() ? PLAY_STORE_URL : APPLE_STORE_URL)

const GPSButton = ({ elementRef, gpsInfo, className }) => {
  const dispatch = useDispatch()
  const gpsLink = useMemo(() => getGpsLink(gpsInfo), [gpsInfo])

  const delayRedirectToStore = useCallback(
    () =>
      delay(() => {
        if (hasNotBeenRedirected()) {
          dispatch(navigateToExternalUrl({ url: getGPSFallbackLink() })) // Then, open store URL
        }
      }, 3000),
    []
  )

  const onClick = useCallback(() => {
    dispatch(navigateToExternalUrl({ url: gpsLink })) // First open mappy:// link
    delayRedirectToStore()
  }, [gpsLink, delayRedirectToStore])

  if (!gpsLink) return <></>

  return (
    <ItineraryButtonContainer className={className}>
      <TagActionButton type={RI_CLIC_ITI} key={gpsInfo}>
        <RectangleActionButton
          color={COLOR_BLUE}
          elementRef={elementRef}
          onClick={onClick}
          deferClick
          tagData={{
            tagInfo: { provider: gpsInfo.provider, tag: PUB_TAG.PUB_MULTIPATH_GPS },
            type: TAG_MULTIPATH_CTA,
            shouldTagImpression: true
          }}
          label={gpsInfo.label}
          iconUrl={mappyOutline}
          ssrWhite
          dataset={{ [CLICKED_BUTTON]: gpsInfo.label }}
          size={SIZE_MEDIUM}
        />
      </TagActionButton>
    </ItineraryButtonContainer>
  )
}

export default withOnlyPE(GPSButton)
